import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { PHOTOS } from "../lib/data";

export default function CTABanner({
    eyebrow = "Free Estimate",
    title = "Ready to plan your next outdoor project?",
    sub = "Tell us about your property — we'll be in touch within one business day.",
    primaryHref = "/contact",
    primaryLabel = "Request a Quote",
    secondaryHref = "/gallery",
    secondaryLabel = "View Gallery",
}) {
    return (
        <section data-testid="cta-banner" className="px-4 sm:px-8 my-24">
            <div className="max-w-7xl mx-auto relative overflow-hidden rounded-3xl bg-brand-primary text-white">
                <div
                    className="absolute inset-0 opacity-25 bg-cover bg-center"
                    style={{ backgroundImage: `url('${PHOTOS.lushFloweringGarden}')` }}
                />
                <div className="relative z-10 px-6 sm:px-16 py-20 grid lg:grid-cols-12 items-end gap-10">
                    <div className="lg:col-span-7">
                        <p className="text-xs uppercase tracking-[0.3em] text-[#B5C5AA] mb-4">{eyebrow}</p>
                        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] font-medium">{title}</h2>
                        <p className="mt-5 text-base sm:text-lg text-[#D6D3C2] max-w-xl">{sub}</p>
                    </div>
                    <div className="lg:col-span-5 flex flex-wrap gap-3 lg:justify-end">
                        <Link
                            to={primaryHref}
                            data-testid="cta-primary"
                            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-brand-bg text-brand-primary text-sm font-semibold hover:bg-white transition-all hover:-translate-y-0.5"
                        >
                            {primaryLabel} <ArrowRight size={18} weight="bold" />
                        </Link>
                        <Link
                            to={secondaryHref}
                            data-testid="cta-secondary"
                            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/40 text-white text-sm font-semibold hover:bg-white/10 transition-all"
                        >
                            {secondaryLabel}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
